import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
    Layout,
    theme,
    Input,
    Row,
    Typography,
    Card,
    Select,
    Collapse,
    Form,
    Checkbox,
    Spin,
    Col
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { newGlAccountAction } from "../../../redux/actions";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewGLA1000 = (props) => {
    //DECLARED VARIABLES
    const { userData } = props;
    const { session } = userData;

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        // getTemplate();
        //ACTIVATE SAVE RIGHTSIDEBAR ACTION
        // dispatch({
        //   type: cnt.RIGHT_SAVE_BTN,
        // });
    }, []);

    function onCancel() {
        navigate("/gla1000", { replace: false });
    }

    const onSubmit = (formValues) => {

        const body = {
            ...formValues,
            method: "POST",
            session,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, definedApi.NewFundSource, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, appLabel.newFundSourceCreatedMsg);
                navigate("/gla1000");
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
            <TopContent pageTitle={appLabel.newFundSource} pageItems={appStatic.newFundSourceItems} />
            <Spin spinning={isLoading} size="large">
                <Card
                    title={
                        <Title level={4} style={{ color: "#000" }}>
                            {appLabel.generalInfo}
                        </Title>
                    }
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form layout="vertical" onFinish={onSubmit}>
                        <Card
                            style={{
                                marginBottom: "3%",
                                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                            }}
                            bordered
                        >

                            <Row style={{ justifyContent: "space-between" }}>
                                <Form.Item
                                    name={"name"}
                                    rules={[{ required: true, message: "Required field" }]}>
                                    <Input style={{ width: "30vh" }} placeholder="Add New Fund" />
                                </Form.Item>
                            </Row>

                        </Card>
                        <Form.Item>
                            <Row>
                                <CustomButton
                                    content="Submit"
                                    style={{
                                        width: "10%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    htmlType="submit"
                                    backgroundColor="#15CCAE"
                                    colorText="black"
                                    hoverBackground="#4FECA0"
                                />
                                <CustomButton
                                    content="Cancel"
                                    style={{
                                        width: "10%",
                                        marginLeft: "1%",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    backgroundColor="#fff"
                                    colorText="black"
                                    hoverBackground="#F5F5F5"
                                    onClick={onCancel}
                                />
                            </Row>
                        </Form.Item>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
    rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(NewGLA1000);
